export default "images/single-room.png";